/* eslint-disable */

// @ts-nocheck

// This file was automatically generated by @icp-sdk/bindgen@0.2.1.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

export const idlFactory = ({IDL}) => {
  const Tokens = IDL.Record({e8s: IDL.Nat64});
  const AssertMissionControlCenterArgs = IDL.Record({
    mission_control_id: IDL.Principal,
    user: IDL.Principal
  });
  const OpenIdPrepareDelegationArgs = IDL.Record({
    jwt: IDL.Text,
    session_key: IDL.Vec(IDL.Nat8),
    salt: IDL.Vec(IDL.Nat8)
  });
  const AuthenticationArgs = IDL.Variant({
    OpenId: OpenIdPrepareDelegationArgs
  });
  const PreparedDelegation = IDL.Record({
    user_key: IDL.Vec(IDL.Nat8),
    expiration: IDL.Nat64
  });
  const OpenIdDelegationProvider = IDL.Variant({
    GitHub: IDL.Null,
    Google: IDL.Null
  });
  const OpenIdData = IDL.Record({
    name: IDL.Opt(IDL.Text),
    locale: IDL.Opt(IDL.Text),
    family_name: IDL.Opt(IDL.Text),
    email: IDL.Opt(IDL.Text),
    picture: IDL.Opt(IDL.Text),
    given_name: IDL.Opt(IDL.Text),
    preferred_username: IDL.Opt(IDL.Text)
  });
  const OpenId = IDL.Record({
    provider: OpenIdDelegationProvider,
    data: OpenIdData
  });
  const Provider = IDL.Variant({
    InternetIdentity: IDL.Null,
    OpenId: OpenId
  });
  const Account = IDL.Record({
    updated_at: IDL.Nat64,
    credits: Tokens,
    mission_control_id: IDL.Opt(IDL.Principal),
    provider: IDL.Opt(Provider),
    owner: IDL.Principal,
    created_at: IDL.Nat64
  });
  const Authentication = IDL.Record({
    delegation: PreparedDelegation,
    account: Account
  });
  const JwtFindProviderError = IDL.Variant({
    BadClaim: IDL.Text,
    BadSig: IDL.Text,
    NoMatchingProvider: IDL.Null
  });
  const JwtVerifyError = IDL.Variant({
    WrongKeyType: IDL.Null,
    MissingKid: IDL.Null,
    BadClaim: IDL.Text,
    BadSig: IDL.Text,
    NoKeyForKid: IDL.Null
  });
  const GetOrRefreshJwksError = IDL.Variant({
    InvalidConfig: IDL.Text,
    MissingKid: IDL.Null,
    BadClaim: IDL.Text,
    KeyNotFoundCooldown: IDL.Null,
    CertificateNotFound: IDL.Null,
    BadSig: IDL.Text,
    MissingLastAttempt: IDL.Text,
    KeyNotFound: IDL.Null,
    FetchFailed: IDL.Text
  });
  const PrepareDelegationError = IDL.Variant({
    JwtFindProvider: JwtFindProviderError,
    GetCachedJwks: IDL.Null,
    JwtVerify: JwtVerifyError,
    GetOrFetchJwks: GetOrRefreshJwksError,
    DeriveSeedFailed: IDL.Text,
    InvalidObservatoryId: IDL.Text
  });
  const AuthenticationError = IDL.Variant({
    PrepareDelegation: PrepareDelegationError,
    RegisterUser: IDL.Text
  });
  const Result = IDL.Variant({
    Ok: Authentication,
    Err: AuthenticationError
  });
  const CommitProposal = IDL.Record({
    sha256: IDL.Vec(IDL.Nat8),
    proposal_id: IDL.Nat
  });
  const CommitBatch = IDL.Record({
    batch_id: IDL.Nat,
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    chunk_ids: IDL.Vec(IDL.Nat)
  });
  const CreateMissionControlArgs = IDL.Record({
    subnet_id: IDL.Opt(IDL.Principal)
  });
  const CreateOrbiterArgs = IDL.Record({
    block_index: IDL.Opt(IDL.Nat64),
    subnet_id: IDL.Opt(IDL.Principal),
    name: IDL.Opt(IDL.Text),
    user: IDL.Principal
  });
  const InitStorageMemory = IDL.Variant({
    Heap: IDL.Null,
    Stable: IDL.Null
  });
  const InitStorageArgs = IDL.Record({
    system_memory: IDL.Opt(InitStorageMemory)
  });
  const CreateSatelliteArgs = IDL.Record({
    block_index: IDL.Opt(IDL.Nat64),
    subnet_id: IDL.Opt(IDL.Principal),
    storage: IDL.Opt(InitStorageArgs),
    name: IDL.Opt(IDL.Text),
    user: IDL.Principal
  });
  const DeleteControllersArgs = IDL.Record({
    controllers: IDL.Vec(IDL.Principal)
  });
  const DeleteProposalAssets = IDL.Record({
    proposal_ids: IDL.Vec(IDL.Nat)
  });
  const OpenIdAuthProviderDelegationConfig = IDL.Record({
    targets: IDL.Opt(IDL.Vec(IDL.Principal)),
    max_time_to_live: IDL.Opt(IDL.Nat64)
  });
  const OpenIdAuthProviderConfig = IDL.Record({
    delegation: IDL.Opt(OpenIdAuthProviderDelegationConfig),
    client_id: IDL.Text
  });
  const AuthenticationConfigOpenId = IDL.Record({
    observatory_id: IDL.Opt(IDL.Principal),
    providers: IDL.Vec(IDL.Tuple(OpenIdDelegationProvider, OpenIdAuthProviderConfig))
  });
  const AuthenticationConfigInternetIdentity = IDL.Record({
    derivation_origin: IDL.Opt(IDL.Text),
    external_alternative_origins: IDL.Opt(IDL.Vec(IDL.Text))
  });
  const AuthenticationRules = IDL.Record({
    allowed_callers: IDL.Vec(IDL.Principal)
  });
  const AuthenticationConfig = IDL.Record({
    updated_at: IDL.Opt(IDL.Nat64),
    openid: IDL.Opt(AuthenticationConfigOpenId),
    created_at: IDL.Opt(IDL.Nat64),
    version: IDL.Opt(IDL.Nat64),
    internet_identity: IDL.Opt(AuthenticationConfigInternetIdentity),
    rules: IDL.Opt(AuthenticationRules)
  });
  const StorageConfigIFrame = IDL.Variant({
    Deny: IDL.Null,
    AllowAny: IDL.Null,
    SameOrigin: IDL.Null
  });
  const ConfigMaxMemorySize = IDL.Record({
    stable: IDL.Opt(IDL.Nat64),
    heap: IDL.Opt(IDL.Nat64)
  });
  const StorageConfigRawAccess = IDL.Variant({
    Deny: IDL.Null,
    Allow: IDL.Null
  });
  const StorageConfigRedirect = IDL.Record({
    status_code: IDL.Nat16,
    location: IDL.Text
  });
  const StorageConfig = IDL.Record({
    iframe: IDL.Opt(StorageConfigIFrame),
    updated_at: IDL.Opt(IDL.Nat64),
    rewrites: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)))),
    created_at: IDL.Opt(IDL.Nat64),
    version: IDL.Opt(IDL.Nat64),
    max_memory_size: IDL.Opt(ConfigMaxMemorySize),
    raw_access: IDL.Opt(StorageConfigRawAccess),
    redirects: IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, StorageConfigRedirect)))
  });
  const Config = IDL.Record({
    authentication: IDL.Opt(AuthenticationConfig),
    storage: StorageConfig
  });
  const GetCreateCanisterFeeArgs = IDL.Record({user: IDL.Principal});
  const OpenIdGetDelegationArgs = IDL.Record({
    jwt: IDL.Text,
    session_key: IDL.Vec(IDL.Nat8),
    salt: IDL.Vec(IDL.Nat8),
    expiration: IDL.Nat64
  });
  const GetDelegationArgs = IDL.Variant({OpenId: OpenIdGetDelegationArgs});
  const Delegation = IDL.Record({
    pubkey: IDL.Vec(IDL.Nat8),
    targets: IDL.Opt(IDL.Vec(IDL.Principal)),
    expiration: IDL.Nat64
  });
  const SignedDelegation = IDL.Record({
    signature: IDL.Vec(IDL.Nat8),
    delegation: Delegation
  });
  const GetDelegationError = IDL.Variant({
    JwtFindProvider: JwtFindProviderError,
    GetCachedJwks: IDL.Null,
    NoSuchDelegation: IDL.Null,
    JwtVerify: JwtVerifyError,
    GetOrFetchJwks: GetOrRefreshJwksError,
    DeriveSeedFailed: IDL.Text,
    InvalidObservatoryId: IDL.Text
  });
  const Result_1 = IDL.Variant({
    Ok: SignedDelegation,
    Err: GetDelegationError
  });
  const SegmentKind = IDL.Variant({
    Orbiter: IDL.Null,
    MissionControl: IDL.Null,
    Satellite: IDL.Null
  });
  const CyclesTokens = IDL.Record({e12s: IDL.Nat64});
  const FactoryFee = IDL.Record({
    updated_at: IDL.Nat64,
    fee_cycles: CyclesTokens,
    fee_icp: IDL.Opt(Tokens)
  });
  const ProposalStatus = IDL.Variant({
    Initialized: IDL.Null,
    Failed: IDL.Null,
    Open: IDL.Null,
    Rejected: IDL.Null,
    Executed: IDL.Null,
    Accepted: IDL.Null
  });
  const AssetsUpgradeOptions = IDL.Record({
    clear_existing_assets: IDL.Opt(IDL.Bool)
  });
  const SegmentsDeploymentOptions = IDL.Record({
    orbiter: IDL.Opt(IDL.Text),
    mission_control_version: IDL.Opt(IDL.Text),
    satellite_version: IDL.Opt(IDL.Text)
  });
  const ProposalType = IDL.Variant({
    AssetsUpgrade: AssetsUpgradeOptions,
    SegmentsDeployment: SegmentsDeploymentOptions
  });
  const Proposal = IDL.Record({
    status: ProposalStatus,
    updated_at: IDL.Nat64,
    sha256: IDL.Opt(IDL.Vec(IDL.Nat8)),
    executed_at: IDL.Opt(IDL.Nat64),
    owner: IDL.Principal,
    created_at: IDL.Nat64,
    version: IDL.Opt(IDL.Nat64),
    proposal_type: ProposalType
  });
  const RateConfig = IDL.Record({
    max_tokens: IDL.Nat64,
    time_per_token_ns: IDL.Nat64
  });
  const HttpRequest = IDL.Record({
    url: IDL.Text,
    method: IDL.Text,
    body: IDL.Vec(IDL.Nat8),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    certificate_version: IDL.Opt(IDL.Nat16)
  });
  const Memory = IDL.Variant({Heap: IDL.Null, Stable: IDL.Null});
  const StreamingCallbackToken = IDL.Record({
    memory: Memory,
    token: IDL.Opt(IDL.Text),
    sha256: IDL.Opt(IDL.Vec(IDL.Nat8)),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    index: IDL.Nat64,
    encoding_type: IDL.Text,
    full_path: IDL.Text
  });
  const StreamingStrategy = IDL.Variant({
    Callback: IDL.Record({
      token: StreamingCallbackToken,
      callback: IDL.Func([], [], [])
    })
  });
  const HttpResponse = IDL.Record({
    body: IDL.Vec(IDL.Nat8),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    streaming_strategy: IDL.Opt(StreamingStrategy),
    status_code: IDL.Nat16
  });
  const StreamingCallbackHttpResponse = IDL.Record({
    token: IDL.Opt(StreamingCallbackToken),
    body: IDL.Vec(IDL.Nat8)
  });
  const InitAssetKey = IDL.Record({
    token: IDL.Opt(IDL.Text),
    collection: IDL.Text,
    name: IDL.Text,
    description: IDL.Opt(IDL.Text),
    encoding_type: IDL.Opt(IDL.Text),
    full_path: IDL.Text
  });
  const InitUploadResult = IDL.Record({batch_id: IDL.Nat});
  const ListOrderField = IDL.Variant({
    UpdatedAt: IDL.Null,
    Keys: IDL.Null,
    CreatedAt: IDL.Null
  });
  const ListOrder = IDL.Record({field: ListOrderField, desc: IDL.Bool});
  const TimestampMatcher = IDL.Variant({
    Equal: IDL.Nat64,
    Between: IDL.Tuple(IDL.Nat64, IDL.Nat64),
    GreaterThan: IDL.Nat64,
    LessThan: IDL.Nat64
  });
  const ListMatcher = IDL.Record({
    key: IDL.Opt(IDL.Text),
    updated_at: IDL.Opt(TimestampMatcher),
    description: IDL.Opt(IDL.Text),
    created_at: IDL.Opt(TimestampMatcher)
  });
  const ListPaginate = IDL.Record({
    start_after: IDL.Opt(IDL.Text),
    limit: IDL.Opt(IDL.Nat64)
  });
  const ListParams = IDL.Record({
    order: IDL.Opt(ListOrder),
    owner: IDL.Opt(IDL.Principal),
    matcher: IDL.Opt(ListMatcher),
    paginate: IDL.Opt(ListPaginate)
  });
  const AssetKey = IDL.Record({
    token: IDL.Opt(IDL.Text),
    collection: IDL.Text,
    owner: IDL.Principal,
    name: IDL.Text,
    description: IDL.Opt(IDL.Text),
    full_path: IDL.Text
  });
  const AssetEncodingNoContent = IDL.Record({
    modified: IDL.Nat64,
    sha256: IDL.Vec(IDL.Nat8),
    total_length: IDL.Nat
  });
  const AssetNoContent = IDL.Record({
    key: AssetKey,
    updated_at: IDL.Nat64,
    encodings: IDL.Vec(IDL.Tuple(IDL.Text, AssetEncodingNoContent)),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    created_at: IDL.Nat64,
    version: IDL.Opt(IDL.Nat64)
  });
  const ListResults = IDL.Record({
    matches_pages: IDL.Opt(IDL.Nat64),
    matches_length: IDL.Nat64,
    items_page: IDL.Opt(IDL.Nat64),
    items: IDL.Vec(IDL.Tuple(IDL.Text, AssetNoContent)),
    items_length: IDL.Nat64
  });
  const ControllerKind = IDL.Variant({
    Emulator: IDL.Null,
    Automation: IDL.Null
  });
  const ControllerScope = IDL.Variant({
    Write: IDL.Null,
    Admin: IDL.Null,
    Submit: IDL.Null
  });
  const Controller = IDL.Record({
    updated_at: IDL.Nat64,
    metadata: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    kind: IDL.Opt(ControllerKind),
    created_at: IDL.Nat64,
    scope: ControllerScope,
    expires_at: IDL.Opt(IDL.Nat64)
  });
  const CustomDomain = IDL.Record({
    updated_at: IDL.Nat64,
    created_at: IDL.Nat64,
    version: IDL.Opt(IDL.Nat64),
    bn_id: IDL.Opt(IDL.Text)
  });
  const PaymentStatus = IDL.Variant({
    Refunded: IDL.Null,
    Acknowledged: IDL.Null,
    Completed: IDL.Null
  });
  const IcpPayment = IDL.Record({
    status: PaymentStatus,
    updated_at: IDL.Nat64,
    block_index_payment: IDL.Nat64,
    mission_control_id: IDL.Opt(IDL.Principal),
    created_at: IDL.Nat64,
    block_index_refunded: IDL.Opt(IDL.Nat64)
  });
  const IcrcPaymentKey = IDL.Record({
    block_index: IDL.Nat64,
    ledger_id: IDL.Principal
  });
  const Account_1 = IDL.Record({
    owner: IDL.Principal,
    subaccount: IDL.Opt(IDL.Vec(IDL.Nat8))
  });
  const IcrcPayment = IDL.Record({
    status: PaymentStatus,
    updated_at: IDL.Nat64,
    created_at: IDL.Nat64,
    block_index_refunded: IDL.Opt(IDL.Nat64),
    purchaser: Account_1
  });
  const ListProposalsOrder = IDL.Record({desc: IDL.Bool});
  const ListProposalsPaginate = IDL.Record({
    start_after: IDL.Opt(IDL.Nat),
    limit: IDL.Opt(IDL.Nat)
  });
  const ListProposalsParams = IDL.Record({
    order: IDL.Opt(ListProposalsOrder),
    paginate: IDL.Opt(ListProposalsPaginate)
  });
  const ProposalKey = IDL.Record({proposal_id: IDL.Nat});
  const ListProposalResults = IDL.Record({
    matches_length: IDL.Nat64,
    items: IDL.Vec(IDL.Tuple(ProposalKey, Proposal)),
    items_length: IDL.Nat64
  });
  const StorableSegmentKind = IDL.Variant({
    Orbiter: IDL.Null,
    Satellite: IDL.Null
  });
  const ListSegmentsArgs = IDL.Record({
    segment_id: IDL.Opt(IDL.Principal),
    segment_kind: IDL.Opt(StorableSegmentKind)
  });
  const SegmentKey = IDL.Record({
    user: IDL.Principal,
    segment_id: IDL.Principal,
    segment_kind: StorableSegmentKind
  });
  const Segment = IDL.Record({
    updated_at: IDL.Nat64,
    metadata: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    segment_id: IDL.Principal,
    created_at: IDL.Nat64
  });
  const SetAuthenticationConfig = IDL.Record({
    openid: IDL.Opt(AuthenticationConfigOpenId),
    version: IDL.Opt(IDL.Nat64),
    internet_identity: IDL.Opt(AuthenticationConfigInternetIdentity),
    rules: IDL.Opt(AuthenticationRules)
  });
  const SetController = IDL.Record({
    metadata: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    kind: IDL.Opt(ControllerKind),
    scope: ControllerScope,
    expires_at: IDL.Opt(IDL.Nat64)
  });
  const SetControllersArgs = IDL.Record({
    controller: SetController,
    controllers: IDL.Vec(IDL.Principal)
  });
  const FeesArgs = IDL.Record({
    fee_cycles: CyclesTokens,
    fee_icp: IDL.Opt(Tokens)
  });
  const SetSegmentsArgs = IDL.Record({
    metadata: IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text))),
    segment_id: IDL.Principal,
    segment_kind: StorableSegmentKind
  });
  const SetSegmentMetadataArgs = IDL.Record({
    metadata: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    segment_id: IDL.Principal,
    segment_kind: StorableSegmentKind
  });
  const SetStorageConfig = IDL.Record({
    iframe: IDL.Opt(StorageConfigIFrame),
    rewrites: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)),
    headers: IDL.Vec(IDL.Tuple(IDL.Text, IDL.Vec(IDL.Tuple(IDL.Text, IDL.Text)))),
    version: IDL.Opt(IDL.Nat64),
    max_memory_size: IDL.Opt(ConfigMaxMemorySize),
    raw_access: IDL.Opt(StorageConfigRawAccess),
    redirects: IDL.Opt(IDL.Vec(IDL.Tuple(IDL.Text, StorageConfigRedirect)))
  });
  const UnsetSegmentsArgs = IDL.Record({
    segment_id: IDL.Principal,
    segment_kind: StorableSegmentKind
  });
  const UploadChunk = IDL.Record({
    content: IDL.Vec(IDL.Nat8),
    batch_id: IDL.Nat,
    order_id: IDL.Opt(IDL.Nat)
  });
  const UploadChunkResult = IDL.Record({chunk_id: IDL.Nat});

  return IDL.Service({
    add_credits: IDL.Func([IDL.Principal, Tokens], [], []),
    add_invitation_code: IDL.Func([IDL.Text], [], []),
    assert_mission_control_center: IDL.Func([AssertMissionControlCenterArgs], [], []),
    authenticate: IDL.Func([AuthenticationArgs], [Result], []),
    commit_proposal: IDL.Func([CommitProposal], [IDL.Null], []),
    commit_proposal_asset_upload: IDL.Func([CommitBatch], [], []),
    commit_proposal_many_assets_upload: IDL.Func([IDL.Vec(CommitBatch)], [], []),
    count_proposals: IDL.Func([], [IDL.Nat64], []),
    create_mission_control: IDL.Func([CreateMissionControlArgs], [IDL.Principal], []),
    create_orbiter: IDL.Func([CreateOrbiterArgs], [IDL.Principal], []),
    create_satellite: IDL.Func([CreateSatelliteArgs], [IDL.Principal], []),
    del_controllers: IDL.Func([DeleteControllersArgs], [], []),
    del_custom_domain: IDL.Func([IDL.Text], [], []),
    delete_proposal_assets: IDL.Func([DeleteProposalAssets], [], []),
    get_account: IDL.Func([], [IDL.Opt(Account)], []),
    get_auth_config: IDL.Func([], [IDL.Opt(AuthenticationConfig)], []),
    get_config: IDL.Func([], [Config], []),
    get_create_orbiter_fee: IDL.Func([GetCreateCanisterFeeArgs], [IDL.Opt(Tokens)], []),
    get_create_satellite_fee: IDL.Func([GetCreateCanisterFeeArgs], [IDL.Opt(Tokens)], []),
    get_credits: IDL.Func([], [Tokens], []),
    get_delegation: IDL.Func([GetDelegationArgs], [Result_1], []),
    get_fee: IDL.Func([SegmentKind], [FactoryFee], []),
    get_or_init_account: IDL.Func([], [Account], []),
    get_proposal: IDL.Func([IDL.Nat], [IDL.Opt(Proposal)], []),
    get_rate_config: IDL.Func([SegmentKind], [RateConfig], []),
    get_storage_config: IDL.Func([], [StorageConfig], []),
    http_request: IDL.Func([HttpRequest], [HttpResponse], []),
    http_request_streaming_callback: IDL.Func(
      [StreamingCallbackToken],
      [StreamingCallbackHttpResponse],
      []
    ),
    init_proposal: IDL.Func([ProposalType], [IDL.Nat, Proposal], []),
    init_proposal_asset_upload: IDL.Func([InitAssetKey, IDL.Nat], [InitUploadResult], []),
    init_proposal_many_assets_upload: IDL.Func(
      [IDL.Vec(InitAssetKey), IDL.Nat],
      [IDL.Vec(IDL.Tuple(IDL.Text, InitUploadResult))],
      []
    ),
    list_accounts: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Principal, Account))], []),
    list_assets: IDL.Func([IDL.Text, ListParams], [ListResults], []),
    list_controllers: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Principal, Controller))], []),
    list_custom_domains: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Text, CustomDomain))], []),
    list_icp_payments: IDL.Func([], [IDL.Vec(IDL.Tuple(IDL.Nat64, IcpPayment))], []),
    list_icrc_payments: IDL.Func([], [IDL.Vec(IDL.Tuple(IcrcPaymentKey, IcrcPayment))], []),
    list_proposals: IDL.Func([ListProposalsParams], [ListProposalResults], []),
    list_segments: IDL.Func([ListSegmentsArgs], [IDL.Vec(IDL.Tuple(SegmentKey, Segment))], []),
    reject_proposal: IDL.Func([CommitProposal], [IDL.Null], []),
    set_auth_config: IDL.Func([SetAuthenticationConfig], [AuthenticationConfig], []),
    set_controllers: IDL.Func([SetControllersArgs], [], []),
    set_custom_domain: IDL.Func([IDL.Text, IDL.Opt(IDL.Text)], [], []),
    set_fee: IDL.Func([SegmentKind, FeesArgs], [], []),
    set_many_segments: IDL.Func([IDL.Vec(SetSegmentsArgs)], [IDL.Vec(Segment)], []),
    set_rate_config: IDL.Func([SegmentKind, RateConfig], [], []),
    set_segment: IDL.Func([SetSegmentsArgs], [Segment], []),
    set_segment_metadata: IDL.Func([SetSegmentMetadataArgs], [Segment], []),
    set_storage_config: IDL.Func([SetStorageConfig], [StorageConfig], []),
    submit_proposal: IDL.Func([IDL.Nat], [IDL.Nat, Proposal], []),
    unset_many_segments: IDL.Func([IDL.Vec(UnsetSegmentsArgs)], [], []),
    unset_segment: IDL.Func([UnsetSegmentsArgs], [], []),
    upload_proposal_asset_chunk: IDL.Func([UploadChunk], [UploadChunkResult], [])
  });
};

export const init = ({IDL}) => {
  return [];
};
